export default __webpack_public_path__ + "static/apple-touch-icon.png";